import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiDollarSign } = FiIcons;

const Logo = ({ className = "", iconClassName = "h-8 w-8", textClassName = "text-xl", dark = false }) => {
  const houseColor = dark ? 'text-blue-400' : 'text-blue-600';
  const siteColor = dark ? 'text-blue-400' : 'text-blue-600';
  const restColor = dark ? 'text-white' : 'text-gray-900';
  
  // Money styling
  const billBg = dark ? 'bg-green-900' : 'bg-green-100';
  const billBorder = dark ? 'border-green-700' : 'border-green-300';
  const billText = dark ? 'text-green-400' : 'text-green-700';

  return (
    <div className={`flex items-center ${className}`}>
      {/* Composite Icon: House + Banknote */}
      <div className="relative mr-2">
        {/* House Icon */}
        <SafeIcon 
          icon={FiHome} 
          className={`${iconClassName} ${houseColor}`} 
        />
        
        {/* Banknote Representation (Styled box with dollar sign) */}
        <div className={`absolute -bottom-1.5 -right-2.5 flex items-center justify-center h-4 w-6 ${billBg} border ${billBorder} rounded-sm shadow-sm transform -rotate-12`}>
           <SafeIcon 
            icon={FiDollarSign} 
            className={`h-3 w-3 ${billText}`} 
          />
        </div>
      </div>
      
      <span className={`ml-2 font-bold tracking-tight ${textClassName}`}>
        <span className={siteColor}>site</span>
        <span className={restColor}>2rent.com</span>
      </span>
    </div>
  );
};

export default Logo;